export default __webpack_public_path__ + "3a9069935fd92bd9e4ec3c89ef95b268.png";